import { Injectable } from '@angular/core';
import { IAnalyticsService, EventProperties, UserProperties } from './analytics.interface';

declare global {
  interface Window {
    posthog?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class PosthogAnalyticsService implements IAnalyticsService {
  private posthog: any;

  constructor() {
    this.init();
  }

  init(): void {
    // PostHog is already initialized in main.ts, just get the reference
    if (typeof window !== 'undefined' && window.posthog) {
      this.posthog = window.posthog;
      console.log('PostHog analytics service connected');
    } else {
      console.warn('PostHog is not available. Check main.ts initialization');
    }
  }

  trackEvent(eventName: string, properties?: EventProperties): void {
    if (this.posthog) {
      this.posthog.capture(eventName, properties);
    } else {
      console.warn(`PostHog not initialized. Event not tracked: ${eventName}`);
    }
  }

  trackPageView(pageName: string, properties?: EventProperties): void {
    if (this.posthog) {
      this.posthog.capture('$pageview', {
        $current_url: pageName,
        ...properties
      });
    } else {
      console.warn(`PostHog not initialized. Page view not tracked: ${pageName}`);
    }
  }

  identify(userId: string, properties?: UserProperties): void {
    if (this.posthog) {
      this.posthog.identify(userId, properties);
    } else {
      console.warn(`PostHog not initialized. User not identified: ${userId}`);
    }
  }

  setUserProperties(properties: UserProperties): void {
    if (this.posthog) {
      this.posthog.people.set(properties);
    } else {
      console.warn('PostHog not initialized. User properties not set');
    }
  }

  reset(): void {
    if (this.posthog) {
      this.posthog.reset();
    } else {
      console.warn('PostHog not initialized. Cannot reset');
    }
  }
}